module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fc-Gb-Hc 后背.b116091f.png";